export default {
  name: 'marking--printJournalElement',
  apiService: 'shoes',
  apiPath: '/admin/print_journal_element',
};